import { CheckCircle2, AlertTriangle, HelpCircle, MinusCircle, AlertCircle, BadgeCheck } from "lucide-react";

export const STATUS_STYLE = {
  "Observed present": { cls: "bg-green-50 text-green-800 border-green-300", Icon: CheckCircle2 },
  "Evidence of improvement opportunity": { cls: "bg-orange-50 text-orange-800 border-orange-300", Icon: AlertTriangle },
  "Possible indication": { cls: "bg-yellow-50 text-yellow-900 border-yellow-300", Icon: HelpCircle },
  "Not found in checked sources": { cls: "bg-slate-100 text-slate-700 border-slate-300", Icon: MinusCircle },
  "Unable to assess": { cls: "bg-purple-50 text-purple-800 border-purple-300", Icon: AlertCircle },
  "Confirmed by restaurant": { cls: "bg-blue-50 text-blue-800 border-blue-300", Icon: BadgeCheck },
};

export const RESEARCH_STATUS = {
  not_researched: { label: "Not researched", cls: "bg-slate-100 text-slate-600" },
  queued: { label: "Queued", cls: "bg-slate-200 text-slate-800" },
  running: { label: "Researching", cls: "bg-orange-100 text-orange-800" },
  completed: { label: "Researched", cls: "bg-green-100 text-green-800" },
  partial: { label: "Partial research", cls: "bg-yellow-100 text-yellow-900" },
  failed: { label: "Research failed", cls: "bg-red-100 text-red-800" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-700" },
};

export const QUAL_STATUSES = ["Not contacted", "Opportunity identified", "Discovery scheduled", "Qualified", "Nurture", "Not a fit"];

export const QUAL_CHECKS = [
  ["confirmed_need", "Confirmed relevant need"],
  ["explicit_interest", "Explicit interest expressed"],
  ["decision_maker", "Decision maker (or confirmed path to one)"],
  ["agreed_next_step", "Agreed next step"],
];

export const RTYPES = [
  ["full_service", "Full service"],
  ["quick_service", "Quick service"],
  ["cafe", "Cafe"],
  ["bar", "Bar"],
  ["food_truck", "Food truck"],
];

export const CATEGORY_ORDER = ["website", "social", "reviews", "ordering", "marketplaces", "pos", "loyalty", "phone_ai", "menus", "other"];
